import {BaseViewModel} from "../../../infrastructure/models/base-view-model";
import {computed} from "mobx";
import {PartialGameDomainModel} from "../../../domain/partial-game/models/partial-game-domain-model";
import {GameCenterLinkModel} from "../../../containers/game-center-container/models/game-center.link-model";
import {WINNER_STATUSES} from "../../../core/consts";
import {GameCenterHashParamsModel} from "../../../containers/game-center-container/models/game-center.hash-params-model";

export class StandingWidgetLiveGameViewModel extends BaseViewModel {
  domainModel: PartialGameDomainModel;
  liveGameStatus: Number;

  constructor(domainModel: PartialGameDomainModel, liveGameStatus: WINNER_STATUSES) {
    super(domainModel);

    this.liveGameStatus = liveGameStatus;
  }

  @computed get tooltipLabel(): String {
    return `${this.domainModel.homeCompetitor.name} ${this.domainModel.homeCompetitor.score} - ${this.domainModel.awayCompetitor.score} ${this.domainModel.awayCompetitor.name}`;
  }

  @computed get winnerStatus(): WINNER_STATUSES {
    const winnerStatus: WINNER_STATUSES = this.liveGameStatus;

    return winnerStatus;
  }

  get linkModel(): GameCenterLinkModel {
    const hashParams: GameCenterHashParamsModel = new GameCenterHashParamsModel({id: this.domainModel.id});
    const linkModel: GameCenterLinkModel = new GameCenterLinkModel(this.domainModel.matchupId, this.domainModel.competition.sport.nameForURL, this.domainModel.competition.nameForURL, this.domainModel.nameForUrl, hashParams, this.domainModel.isFollow);

    return linkModel;
  }
}

